module.exports = __webpack_public_path__ + "static/media/icon_enterprise.c1c6e2f8.svg";